//@flow

import React from 'react';
import slugify from '@sindresorhus/slugify';
import { FormGroup } from 'reactstrap';
import { Button } from 'reactstrap';
import { 
  object,
  // string
} from 'yup';
import { Formik, FormikValues } from 'formik';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import makeUrl from '../../../lib/makeUrl';
import { LodgeDateRangePicker } from '.';
import InputSearchQuery from './InputSearchQuery';
import { CustomCounter } from '../../../components';
import { setCookies15Mins, getFromCookies as getFromCookiesOrDefault } from '../helpers';

import 'bootstrap-daterangepicker/daterangepicker.css';

type Props = RouteComponentProps & {
  closeSearchForm: () => void,
  onSuccess: () => void,
};

const SearchFormSchema = object().shape({
  queryName: object()
    .required('Please enter where do you wanna go!')
    .nullable(),
  // checkinDate: string().required('Please enter your checkin date'),
  // checkoutDate: string().required('Please enter your checkout date'),
});

function LodgeSearchForm(props: Props) {
  function handleSubmit(values: FormikValues) {
    const { history, onSuccess } = props;
    const { documentType, name, id, address, region } = values.queryName;
    const userChoosedToSearch = choice => documentType === choice;

    setCookies15Mins(values);

    const place = 'locality';
    if (userChoosedToSearch(place))
      history.push({
        pathname: '/lodges',
        search: `?placeId=${id}&placeName=${slugify(name)}&region=${region.toLowerCase()}`,
      });

    if (userChoosedToSearch('lodge'))
      history.push({ pathname: makeUrl.goToLodgeDetails(name, id, address) });

    onSuccess();
  }

  return (
    <Formik
      enableReinitialize
      validationSchema={SearchFormSchema}
      initialValues={getFromCookiesOrDefault()}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, handleSubmit, errors }) => {
        return (
          <React.Fragment>
            <FormGroup>
              <InputSearchQuery
                defaultValue={values.queryName}
                onChange={setFieldValue}
                onItemClick={item => setFieldValue('queryName', item[0])}
              />
              {errors.queryName && <div className="error">{errors.queryName}</div>}
            </FormGroup>

            <FormGroup>
              <LodgeDateRangePicker />
            </FormGroup>
            <CustomCounter minValue={1}/>
            <FormGroup className="lodge_search_button_container">
              <Button color="yellow" onClick={handleSubmit} id="lodge-search-button">
                Search
              </Button>
            </FormGroup>
          </React.Fragment>
        );
      }}
    </Formik>
  );
}

LodgeSearchForm.defaultProps = {
  onSuccess: () => {},
};

export default withRouter(LodgeSearchForm);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Common/LodgeSearchForm.js